import { OptionLike } from "helpers/OptionHelper";
import { BaseModel } from "./BaseModel";
import { ConcessionaireProps } from "./types";

export class Concessionaire extends BaseModel<ConcessionaireProps> {
	id: string;
	name: string;
	concessionStartDate: Date;
	concessionEndDate: Date;
	active: boolean;

	constructor(data: ConcessionaireProps) {
		super(data);
		this.id = data.id;
		this.name = data.name;
		this.concessionStartDate = data.concessionStartDate;
		this.concessionEndDate = data.concessionEndDate;
		this.active = data.active;
	}

	toOption = (): OptionLike => {
		return { ...this, label: this.name, value: this.id };
	};
}
